<template>
  <div>
    <h3 class="mb-3">
      {{ $t('host.label.serviceType') }}*
    </h3>

    <v-autocomplete
      v-if="!isLoading && serviceTypes.length >= 1"
      @change="handleSelect"
      :no-data-text="$t('table.noResults')"
      :items="serviceTypes"
      :loading="isLoading"
      :value="value"
      :rules="rules"
      item-value="value"
      item-text="text"
      cache-items
      clearable
      outlined
      multiple
    >
      <template v-slot:item="data">
        <div class="d-flex align-center">
          <v-img
            width="24"
            height="24"
            class="mr-2"
            v-html="handleGetIcon(data.item.value)"
          />
          <span class="body-2 grey--text text--darken-2">
            {{ data.item.text }}
          </span>
        </div>
      </template>
      <template v-slot:selection="data">
        <div
          class="d-flex grey lighten-2 py-1 pr-3 pl-1 mr-1 mb-1 rounded-pill align-center"
        >
          <v-img
            width="24"
            height="24"
            class="mr-2"
            v-html="handleGetIcon(data.item.value)"
          />
          <span class="body-2 grey--text text--darken-2">
            {{ data.item.text }}
          </span>
        </div>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import HCheckbox from '@/components/app/HCheckbox'
import { mapActions, mapGetters } from 'vuex'
import { icons } from '@/util/iconsSVG'

export default {
  name: 'HostServiceTypeSelect',

  components: {
    HCheckbox,
  },

  props: {
    rules: {
      required: false,
    },

    value: {
      type: [Array, String],
    },
  },

  data() {
    return {
      selectedServiceTypes: [],
      serviceTypes: [],
      isLoading: true,
      search: null,
    }
  },

  mounted() {
    this.handleMountServiceObject()
  },

  computed: {
    ...mapGetters(['hostServiceTypes']),
  },

  methods: {
    ...mapActions(['fetchHostServiceTypes']),

    handleSelect(value) {
      this.$emit('input', value)
    },

    handleGetIcon(type) {
      return icons[type]
    },

    handleMountServiceObject() {
      this.isLoading = true

      Promise.resolve(this.fetchHostServiceTypes())
        .then(() => {
          this.hostServiceTypes.map((service) => {
            this.serviceTypes.push({
              text: this.$t(`type.${service}`),
              value: service,
            })
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
  },
}
</script>
